"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var DISPLAY_TIMEOUT = 1000;
var Container =
/*#__PURE__*/
(0, _styled.default)("div", {
  target: "eiokus70"
})({
  position: 'absolute',
  padding: '5px 8px',
  bottom: 0,
  right: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  borderRadius: '5px 0 0 0'
});
var Section =
/*#__PURE__*/
(0, _styled.default)("span", {
  target: "eiokus71"
})({
  fontSize: 12
});
var Delimiter =
/*#__PURE__*/
(0, _styled.default)("span", {
  target: "eiokus72"
})({
  margin: '0px 5px',
  fontSize: 12
});

var Dimensions =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Dimensions, _Component);

  function Dimensions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Dimensions);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Dimensions).call(this, props));
    _this.state = (0, _objectSpread2.default)({}, props, {
      isVisible: false
    });
    _this.hideTimeout = null;
    return _this;
  }

  (0, _createClass2.default)(Dimensions, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var isVisible = this.state.isVisible;

      if (isVisible) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = setTimeout(function () {
          _this2.setState({
            isVisible: false
          });
        }, DISPLAY_TIMEOUT);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.hideTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height;
      return isVisible ? _react.default.createElement(Container, null, _react.default.createElement(Section, null, "".concat(width, "px")), _react.default.createElement(Delimiter, null, "x"), _react.default.createElement(Section, null, "".concat(height, "px"))) : null;
    }
  }]);
  return Dimensions;
}(_react.Component);

Dimensions.getDerivedStateFromProps = function (nextProps, prevState) {
  if (nextProps.width !== prevState.width || nextProps.height !== prevState.height) {
    return (0, _objectSpread2.default)({}, nextProps, {
      isVisible: true
    });
  }

  return null;
};

Dimensions.propTypes = {
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired
};
var _default = Dimensions;
exports.default = _default;